import styled from 'styled-components'

export const ContainerBottomSheet = styled.div`
  .bottom-sheet__slot {
    height: auto;
    padding: 0 !important;
  }
  .bottom-sheet__content {
    position: fixed;
    bottom: 0;
  }
`

export const ContainerBottomSheetInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`
